
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscription-cars/details/vehicles/[vin]",
      function () {
        return require("private-next-pages/subscription-cars/details/vehicles/[vin].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscription-cars/details/vehicles/[vin]"])
      });
    }
  